import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import TeamCapacity from './TeamCapacityGraph';
import TradeCapacity from './TradeCapacityGraph';
import TradepersonCapacity from './TradepersonCapacityGraph';
import ShiftCapacity from './ShiftCapacityGraph';
import { ThemeContext } from '../../../context/theme.context';
import Loader from 'react-spinners/PulseLoader';

interface IProps {}
interface IState {
  isTabLoading: boolean;
}

class TabPane extends React.Component<IProps, IState> {
  private headerText: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private tabObj: TabComponent;
  constructor(props: IProps) {
    super(props);
    this.state = { isTabLoading: false };
    this.headerText = [
      { text: 'Team' },
      { text: 'Trade' },
      { text: 'TradesPerson' },
      { text: 'Shift' },
    ];
    this.tabObj = new TabComponent(props);
  }
  content0() {
    return <TeamCapacity />;
  }
  content1() {
    return <TradeCapacity />;
  }
  content2() {
    return <TradepersonCapacity />;
  }
  /* content3() {
    return <ShiftCapacity />;
  } */

  componentDidUpdate() {
    if (this.context.isChangeTabPane) {
      this.context.setChangeTabPane(false);
    }
  }

  private onTabSelecting = () => {
    this.setState({ isTabLoading: true });
  };

  private onTabSelected = () => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      this.setState({ isTabLoading: false });
    }, 100);
  };

  render() {
    const isDark = this.context?.isDarkMode;
    return (
      <div style={{ position: 'relative' }}>
      <TabComponent
        heightAdjustMode='Auto'
        ref={(el) => {
          this.tabObj = el as TabComponent;
        }}
        statelessTemplates={['directiveTemplates']}
        selecting={this.onTabSelecting}
        selected={this.onTabSelected}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={this.headerText[0]}
            content={this.content0}
          />
          <TabItemDirective
            header={this.headerText[1]}
            content={this.content1}
          />
          <TabItemDirective
            header={this.headerText[2]}
            content={this.content2}
          />
          {/* <TabItemDirective
            header={this.headerText[3]}
            content={this.content3}
          /> */}
        </TabItemsDirective>
      </TabComponent>

        {this.state.isTabLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor:'#22d3ee',
              zIndex: 10,
              borderRadius: '8px',
              marginTop: '200px'
            }}
          >
            <Loader color='#22d3ee' size={10} />
          </div>
        )}
      </div>
    );
  }
}

export default TabPane;